import { Typography } from '@mui/material';
import { AssignmentEntityType, useAssignmentService } from 'domain/shared/assignment';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import { useSubmit } from 'framework/utils';
import { getAssigneeName, isIndividualAssignment } from '../shared/assignmentDisplay';

interface DeleteAssignmentDialogProps {
  assignment: AssignmentEntityType;
  onClose: () => void;
  onDeleted: () => void;
}

const DeleteAssignmentDialog = ({ assignment, onClose, onDeleted }: DeleteAssignmentDialogProps) => {
  const { deleteById } = useAssignmentService();
  const { onSubmit, isLoading } = useSubmit({
    submitMethod: () => deleteById(assignment.id),
    afterSubmit: {
      successMessage: 'The Assignment has been successfully deleted.',
      errorMessage: `Can't delete assignment`,
      execute: () => {
        onDeleted();
        onClose();
      },
    },
  });
  const projectName = assignment.project?.name ?? assignment.target?.displayName;
  const assignee = getAssigneeName(assignment);
  const assigneeText = assignee
    ? `for the ${isIndividualAssignment(assignment) ? 'employee' : 'public service'} '${assignee}'`
    : 'with empty assignee';

  return (
    <Modal
      isOpen
      title="Are you sure?"
      onToggle={() => {
        if (!isLoading) onClose();
      }}
      buttons={[
        <Button
          key="delete"
          color="error"
          variant="contained"
          loading={isLoading}
          disabled={isLoading}
          onClick={() => onSubmit()}
        >
          Delete
        </Button>,
      ]}
    >
      <Typography>{`Do you really want to delete the assignment ${assigneeText} to the project '${projectName}'?`}</Typography>
    </Modal>
  );
};

export default DeleteAssignmentDialog;
